import { toast } from "react-toastify";
import { ANALYTICS_ERROR, ANALYTICS_LOADER, GET_ANALYTICS_VIEWS } from "../actionType";
import axios from "axios";

export const getAnalyticsViews = (clientId, moduleType, filters={}) => async (dispatch) => {
    let tokens = JSON.parse(sessionStorage.getItem("tokens")) || null;
    let authToken = tokens?.token || null;

    if (!authToken) {
        dispatch({ type: ANALYTICS_ERROR });
        return;
    }

    let headers = {
        'Authorization': `Bearer ${authToken}`,
        'Content-Type': 'application/json'
    }

    try {
        dispatch({ type: ANALYTICS_LOADER });

        const queryParams = new URLSearchParams();

        if(filters.display_name){
            queryParams.append("display_name", filters?.display_name);
        }

        if(filters.is_active){
            queryParams.append("is_active", filters?.is_active);
        }

        let response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/views/get-views/${clientId}/${moduleType}?${queryParams.toString()}`, { headers });
        dispatch({ type: GET_ANALYTICS_VIEWS, payload: response?.data?.data });
    }
    catch (err) {
        dispatch({ type: ANALYTICS_ERROR });
        toast.error("Error in fetching analytics views", err);
    }
}